export default __webpack_public_path__ + "static/HalfCircle-435b803ac8b55188d27954b990462117.svg";